<template>
  <section>
    <aTable
      class="travel-table"
      :columns="
        creditLettersTableColumns.map((column) => {
          return column.key !== 'action' ? column : {};
        })
      "
      :data-source="creditLetter.list"
      :loading="creditLetter.loading"
      :pagination="false"
      :scroll="{ x: 1300 }"
      @change="creditLetterTableChange"
    >
      <div slot="customer" slot-scope="record">
        <div v-if="record?.customer?.id">
          <div
            class="dotted-phrase"
            style="width: 200px; display: block"
            v-if="record.customer?.person_type === 'Pessoa Física'"
          >
            {{ record.customer.id }} - {{ record.customer.first_name }}
            {{ record.customer.last_name }}
          </div>
          <div
            class="dotted-phrase"
            style="width: 100px; display: block"
            v-if="record.customer?.person_type === 'Pessoa Jurídica'"
          >
            {{ record.customer.id }} - {{ record.customer.trading_name }}
          </div>
        </div>
        <div v-else>---</div>
      </div>

      <div slot="value" slot-scope="record">
        {{ record.currency | formatCurrency }} {{ record.value | formatPrice }}
      </div>

      <div slot="available_value" slot-scope="record">
        {{ record.currency | formatCurrency }}
        {{ record.available_value | formatPrice }}
      </div>

      <div slot="spent_value" slot-scope="record">
        {{ record.currency | formatCurrency }}
        {{ record.spent_value | formatPrice }}
      </div>

      <div slot="expires_at" slot-scope="record">
        <div v-if="record.expires_at !== '0000-00-00'">
          {{ record.expires_at | formatDate }}
        </div>
        <div v-else>---</div>
      </div>

      <div slot="receipt_date" slot-scope="record">
        <div v-if="record.receipt_date !== '0000-00-00'">
          {{ record.receipt_date | formatDate }}
        </div>
        <div v-else>---</div>
      </div>

      <div slot="issuer" slot-scope="record">
        <div v-if="record.issuer.id">
          <a-tooltip>
            <template slot="title">
              {{ record.issuer.first_name }} {{ record.issuer.last_name }}
            </template>
            <span id="avatar">
              <a-avatar
                v-if="record.issuer.avatar"
                :src="record.issuer.avatar"
                :size="30"
              />
              <a-avatar
                v-else
                class="upper"
                style="color: #f56a00; background-color: #fde3cf"
              >
                {{ record.issuer.first_name.substring(0, 1)
                }}{{ record.issuer.last_name.substring(0, 1) }}
              </a-avatar>
            </span>
          </a-tooltip>
        </div>
        <div v-else><a-avatar icon="user" /></div>
      </div>

      <div slot="created" slot-scope="record">
        {{ record.created | formatDateTime }}
      </div>
    </aTable>

    <div class="a-center mt-30">
      <a-pagination
        show-size-changer
        :default-current="creditLetter.pagination.page"
        :page-size.sync="creditLetter.pagination.perPage"
        :total="creditLetter.pagination.total"
        @change="changeCreditLetterPage"
        @showSizeChange="creditLetterChangePageSize"
      >
      </a-pagination>
    </div>
  </section>
</template>

<script>
import reusableThings from "@/mixins/general/reusableThings";
import creditLetterReusables from "@/components/credit-letters/mixins/creditLetterReusables";

export default {
  name: "ContractModalCreditLettersList",
  props: {
    tempContract: Object,
  },
  components: {},
  mixins: [reusableThings, creditLetterReusables],
  data() {
    return {
      openCreditLetterModal: false,
      creditLetterId: "",
    };
  },
  mounted() {
    this.creditLetter.showParams = false
    this.creditLetter.filters.customerId = this.tempContract.customer_id ?? 1;
    this.getCreditLetters();
  },
  methods: {
    onClickOpenCreditLetterModal(id) {
      this.creditLetterId = id;
      this.openCreditLetterModal = true;
    },
  },
};
</script>
    
<style>
</style>